import { render, staticRenderFns } from "./UserACLAlert.vue?vue&type=template&id=874f1e20&scoped=true&"
import script from "./UserACLAlert.vue?vue&type=script&lang=js&"
export * from "./UserACLAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874f1e20",
  null
  
)

export default component.exports